export default __webpack_public_path__ + "static/media/cp_geo_ca.efb35652.svg";